



















































































































































































































































































































































































//import { BaseTLTableBase, Vue Component, Keypress } from "../../Infrastructure/CorBase/CoreBase";

import { BaseTLTableBase, Vue, Watch, Component, Prop, tlIAmountCzech, tlISODateTimeToLocalNoSecondsString, EnumsService, EnumsFilter, ObjectTypesHelper, Multiselect, Keypress } from "../../Infrastructure/CorBase/CoreBase";
import { BIconAlignTop, BTable } from 'bootstrap-vue';
//interface iBaseList {
//    id: number;
//    name: string;
//}


@Component({
	components: {
		Keypress: () => import('vue-keypress')
	}
})
export default class BaseTLTableRest extends BaseTLTableBase {

	@Prop({ required: true }) itemsData: any; //zakladni datova napln
	@Prop({ required: true }) fields: any;  //jmena sloupců
	@Prop({ required: false }) filters: any;  //filter - seznam filtru a jejich typů

	@Prop({ required: false }) gridFields: any; //odkud co namapovat

	@Prop({ type: String, required: false, default: "" }) design?: string; //design - detail, modal (zatim neni nic)

	@Prop({ type: Boolean, required: false, default: true }) allowDoubleClick?: boolean; //voleni double click, default je true, ale kdyby to bylo potreba nekde zrusit

	@Prop({ type: Boolean, required: false, default: false }) disabled?: boolean; //disablovani cele tabulky

	//nové redesign property
	@Prop({ type: Boolean, required: false, default: true }) showAddButton?: boolean; //zobrazení nové položky (plusko)
	@Prop({ type: String, required: false, default: "baseTable.addNew" }) addButtonName?: string; //popis nove polozky pokud chceme
	@Prop({ type: Boolean, required: false, default: false }) addButtonDisable?: boolean; //disable add button

	@Prop({ type: String, required: false, default: '' }) showAddButtonTooltip?: string; //zobrazení nové položky (plusko) jeho tooltip
	@Prop({ type: String, required: false, default: "buttonIconNovaPolozka" }) addButtonIcon?: string; //icona nove položky

	@Prop({ type: Boolean, required: false, default: false }) showBackButton?: boolean; //zobrazení tlacitko na navrat na predchozi stranku
	@Prop({ type: String, required: false, default: "global.buttonBack" }) showBackButtonTitle!: string; //návratové tlačítko název
	@Prop({ type: String, required: false, default: "global.buttonBackTooltip" }) showBackButtonTooltip?: string; //návratové tlačítko tooltip
	@Prop({ type: Boolean, required: false, default: false }) showBackButton2?: boolean; //2. zobrazení tlacitko na navrat na predchozi stranku
	@Prop({ type: Boolean, required: false, default: false }) showBackButton3?: boolean; //3. zobrazení tlacitko na navrat na predchozi stranku
	@Prop({ type: String, required: false, default: "global.buttonBack" }) showBackButtonTitle2!: string; //2. návratové tlačítko název
	@Prop({ type: String, required: false, default: "global.buttonBackTooltip" }) showBackButtonTooltip2?: string; //2. návratové tlačítko tooltip
	@Prop({ type: String, required: false, default: "global.buttonBack" }) showBackButtonTitle3!: string; //3. návratové tlačítko název
	@Prop({ type: String, required: false, default: "global.buttonBackTooltip" }) showBackButtonTooltip3?: string; //3. návratové tlačítko tooltip
	@Prop({ type: String, required: false, default: "" }) infoRightText!: string; //doplnkovy text v pravo

	@Prop({ type: String, required: false, default: "" }) description?: string; //název - TODO dat to povinne
	@Prop({ type: String, required: false, default: "" }) description2?: string; //název - ten umistovat dole
	@Prop({ type: String, required: true, default: "" }) name?: string; //jednoznačny identifator - podle ktereho ukládá stav
	@Prop({ type: Boolean, required: false, default: false }) allowGrid?: boolean; //je možnost přepnout na grid

	@Prop({ type: Boolean, required: false, default: false }) showInModal?: boolean; //zobrazuje se v modalnim okne, pribýva zaviraci ikona
	@Prop({ type: Boolean, required: false, default: false }) notChangeUrl?: boolean; //nemeni se url filtry, kdyz je tabulka soucasti napr. detailu

	@Prop({ type: Boolean, required: false, default: false }) selected?: boolean; //možnost vybrat , potřeba dodat
	@Prop({ type: Boolean, required: false, default: false }) selectedMultiHelp?: boolean; //zobrazi se i seznam vsech vybranych, ktery jde odklikavat
	@Prop({ type: Array, required: false }) selectedMultiNames!: string[]; //když je selectedMultiHelp je potreba popsat z ceho se budou skladat ten vyber napr,  { "idPersonNavigationLastname", "idPersonNavigationFirstname" }

	@Prop({ type: Boolean, required: false, default: true }) filterSearch?: boolean; //filter viditelnost - vyhledávání
	@Prop({ type: Boolean, required: false, default: true }) filterSearchOn?: boolean; //filter viditelnost - filter podle skupin
	@Prop({ type: Boolean, required: false, default: true }) filterPerPage?: boolean; //filter viditelnost - kolik stránek
	@Prop({ type: Boolean, required: false, default: true }) filterPagination?: boolean; //filter viditelnost - strankovani

	@Prop({ type: String, required: false, default: '' }) buttonDetailName?: string; //vlastní pojmenování tlačítka info
	@Prop({ type: String, required: false, default: "buttonDetail" }) buttonDetailClass?: string; //vlastní tlačítka css class detailu
	@Prop({ type: Boolean, required: false, default: false }) buttonDetail?: boolean; //button action - info tlačitko
	@Prop({ type: String, required: false, default: "ÚpravaObs" }) buttonUpdateName?: string; //vlastní pojmenování tlačítka úprava
	@Prop({ type: Boolean, required: false, default: false }) buttonUpdate?: boolean; //button action - update tlačitko
	@Prop({ type: Boolean, required: false, default: false }) buttonDelete?: boolean; //button action - delete tlačitko
	@Prop({ type: String, required: false, default: "" }) buttonDeleteName?: string; //vlastní pojmenování tlačítka smazat
	@Prop({ type: Boolean, required: false, default: false }) buttonOther?: boolean; //button action - vlastni tlacitko
	@Prop({ type: String, required: false, default: "global.buttonPrintTooltip" }) buttonOtherName?: string; //vlastní pojmenování tlačítka
	@Prop({ type: String, required: false, default: '' }) buttonOtherParam?: string; //button action - vlastni tlacitko - parametry ktery musi splnit aby bylo viditelne
	@Prop({ type: String, required: false, default: "buttonAdd" }) buttonOtherClass?: string; //vlastní tlačítka css class


	@Prop({ type: Boolean, required: false, default: false }) buttonOther2?: boolean; //button action - vlastni tlacitko 2
	@Prop({ type: String, required: false, default: "Other2" }) buttonOtherName2?: string; //vlastní pojmenování tlačítka 2
	@Prop({ type: String, required: false, default: "buttonOther2" }) buttonOtherClass2?: string; //vlastní tlačítka css class, druhe
	@Prop({ type: Boolean, required: false, default: false }) buttonOther3?: boolean; //button action - vlastni tlacitko 3
	@Prop({ type: String, required: false, default: "Other3" }) buttonOtherName3?: string; //vlastní pojmenování tlačítka 3
	@Prop({ type: String, required: false, default: "buttonOther3" }) buttonOtherClass3?: string; //vlastní tlačítka css class, treti
	@Prop({ type: Boolean, required: false, default: false }) buttonOther4?: boolean; //button action - vlastni tlacitko 4
	@Prop({ type: String, required: false, default: "Other4" }) buttonOtherName4?: string; //vlastní pojmenování tlačítka 4
	@Prop({ type: String, required: false, default: "buttonOther4" }) buttonOtherClass4?: string; //vlastní tlačítka css class, ctvrty

	@Prop({ type: Boolean, required: false, default: false }) simpleTable?: boolean; //schování stránkování

	@Prop({ type: Array, required: false }) dropDownList!: any[]; //obsah drop down listu

	@Prop({ type: String, required: false, default: "" }) moreActionIcon?: string; //jaka ma byt pouzita ikona u tlacitka
	@Prop({ type: String, required: false, default: "" }) moreActionIcon2?: string; //jaka ma byt pouzita ikona u tlacitka2
	@Prop({ type: String, required: false, default: "" }) moreActionIcon3?: string; //jaka ma byt pouzita ikona u tlacitka3

	@Prop({ type: String, required: false, default: "" }) moreActionIconVariant?: string; //jaka ma byt pouzita varianta green, red
	@Prop({ type: String, required: false, default: "" }) moreActionIconVariant2?: string; //jaka ma byt pouzita varianta green, red
	@Prop({ type: String, required: false, default: "" }) moreActionIconVariant3?: string; //jaka ma byt pouzita varianta green, red

	@Prop({ type: String, required: false, default: "" }) moreActionTitle?: string; //nazev pro hromadnou akci
	@Prop({ type: String, required: false, default: "" }) moreActionTitle2?: string; //nazev pro hromadnou akci 2
	@Prop({ type: String, required: false, default: "" }) moreActionTitle3?: string; //nazev pro hromadnou akci 3

	@Prop({ type: Boolean, required: false, default: true }) moreActionAllow1?: boolean; //enabale/disable hromadne akce
	@Prop({ type: Boolean, required: false, default: true }) moreActionAllow2?: boolean; //enabale/disable hromadne akce
	@Prop({ type: Boolean, required: false, default: true }) moreActionAllow3?: boolean; //enabale/disable hromadne akce

	@Prop({ type: Boolean, required: false, default: true }) moreActionShow?: boolean; //zobrazeni hromadne akce
	@Prop({ type: Boolean, required: false, default: true }) moreActionShow2?: boolean; //zobrazeni hromadne akce
	@Prop({ type: Boolean, required: false, default: true }) moreActionShow3?: boolean; //zobrazeni hromadne akce
	@Prop({ type: Boolean, required: false, default: true }) moreActionShow4?: boolean; //zobrazeni hromadne akce

	@Prop({ type: String, required: false, default: "" }) moreActionTooltip?: string; //napoveda k akci
	@Prop({ type: String, required: false, default: "" }) moreActionTooltip2?: string; //napoveda k akci 2
	@Prop({ type: String, required: false, default: "" }) moreActionTooltip3?: string; //napoveda k akci 3

	@Prop({ type: Boolean, required: false, default: false }) moreActionAllow1Objects?: boolean; //posilani celych objektu, misto IDcek, pro specialni pripady
	@Prop({ type: String, required: false, default: "" }) defaultSortBy?: string; //sortBy
	@Prop({ type: Boolean, required: false, default: false }) defaultSortDesc?: boolean; //sort desc
	//TODO proč musím použít v LoginHistoryList???
	@Prop({ type: Boolean, required: false, default: true }) isBusyShow?: boolean; //zobrazení spinneru - někde je potřeba použit po fetchi
	@Prop({ type: Boolean, required: false, default: false }) useTagModal?: boolean; //zapnutí možnosti tagů
	@Prop({ type: String, required: false, default: "receiver" }) typeTagModal!: string; // k čemu se bude ukladat tagy 1)content - media 2) taks - ulohy 3) default receiver -zařízení


	@Prop({ type: Number, required: false, default: ObjectTypesHelper.ObjectTypeEnum.Content }) objectType?: ObjectTypesHelper.ObjectTypeEnum;
	@Prop({ type: Boolean, required: false, default: true }) fixedMenu?: boolean; //menu zustava stale nahore, nescroluje
	@Prop({ type: Boolean, required: false, default: false }) onlyOne?: boolean; //vyber pouze jednoho prvku


	@Prop({ type: String, required: false, default: "" }) bottomAddActionTitle?: string; //nazev pro pridani v tabulce   - pro pridani v tabulce
	@Prop({ type: Boolean, required: false, default: true }) bottomAddActionShow?: boolean; //zobrazeni pro pridani v tabulce  -pro pridani v tabulce
	@Prop({ type: String, required: false, default: "" }) bottomAddActionIconVariant?: string; //jaka ma byt pouzita varianta green, red  - pro pridani v tabulce
	@Prop({ type: String, required: false, default: "" }) bottomAddActionIcon?: string; //jaka ma byt pouzita ikona u tlacitka  - pro pridani v tabulce
	@Prop({ type: Boolean, required: false, default: true }) bottomAddActionAllow?: boolean; //povoleni hromadne akce  - pro pridani v tabulce
	@Prop({ type: String, required: false, default: "" }) bottomAddActionTooltip?: string; //tooltip   - - pro pridani v tabulce

	buttonDetailNameTooltip() {
		return this.buttonDetailName == "" ? this.$t('global.buttonDetailTooltip').toString() : this.buttonDetailName;
	}

	buttonDeleteNameTooltip() {
		return this.buttonDeleteName == "" ? this.$t('global.buttonDeleteTooltip').toString() : this.buttonDeleteName;
	}


	buttonNewItemTooltip() {
		return this.buttonDetailName == "" ? this.$t('global.buttonNewItem').toString() : this.showAddButtonTooltip;
	}

	//TODO do predka
	/* heightTable = "200px";*/


	//tohle DO BaseTlComponent
	isBusy = true;
	created() {
		//TODO je to potreba?
		//TEST
		//   this.allowChangeFilter = false;
		//NEVIM
		this.restTable = true;
		// this.isLoadFilterAfterBefore = false;
		this.initBaseProperties();
		super.created();

	}

	//zobrazeni listy s vybranymi filry
	showSelectedFilterBlock(): boolean {
		return (this.filterData as Array<any>).filter(c => (c.selected && !c.isNegative) || (!c.selected && c.isNegative) || (c.selected && c.useEnum)).length > 0 || this.showBackButton == true;
	}

	//changeVisibilityFilterSetting() {
	//    this.showFilterSetting = this.showColumnSetting = false;
	//    this.$emit('changeShowMenu', false);
	//}

	//showColumnSettings() {
	//    this.showColumnSetting = !this.showColumnSetting;
	//    this.showFilterSetting = false;
	//    this.$emit('changeShowMenu', this.showColumnSetting);
	//}

	//      showFilterSettings() {
	//          this.showFilterSetting = !this.showFilterSetting;
	//          this.showColumnSetting = false;
	//          this.$emit('changeShowMenu', this.showFilterSetting);
	//}

	//      showFilterOrColumng(): boolean {
	//          return this.showColumnSetting || this.showFilterSetting;
	//      }

	getSelectedFilters() {
		return (this.filters).filter((c: any) => c.selected && !c.group == true && c.type != 'multi');
	}

	//prepareFilterSelected(item: any): string {
	//    if (item.type == 'datetime') {
	//        return tlISODateTimeToLocalNoSecondsString(item.value);
	//    }
	//    else {
	//        if (item.useOwnEnumsSend) { //vlastni kolekce ve filtru
	//            var sel = (item.useOwnEnumsSendArray as Array<any>).filter((c: any) => c.value == item.value);
	//            return sel.length > 0 ? sel[0].text : '';
	//        }
	//        else {
	//            return item.value;
	//        }
	//    }
	//}

	//popisek do vybranych filtru co se zobrazuji nahore
	//prepareFilterDescription(item: any): string {
	//    if (item.useOwnEnumsSend) { //vlastni kolekce ve filtru
	//        var sel = (item.useOwnEnumsSendArray as Array<any>).filter((c: any) => c.value == item.value);
	//        return sel.length > 0 ? sel[0].description : '';
	//    }
	//    else {
	//        return '';
	//    }
	//}

	getSelectedMultiFilters() {
		return (this.filters).filter((c: any) => c.selected && !c.group == true && c.type == 'multi');
	}

	//getSelectedGroupFilters() {
	//    return this.getFiltersByGroups();
	//}

	removeNegativeFilter(id: any): void {
		var filter = this.filters.filter((c: any) => c.key == id)[0];
		filter.selected = true;
		this.changeParamTable();
	}

	//clearInputFilter(filter: any): void {
	//    if (filter.type == 'datetime') {
	//        var actDate = new Date();
	//        filter.value = filter.moreThan ? new Date(actDate.getFullYear(), actDate.getMonth(), actDate.getDate(), 0, 0) :
	//            new Date(actDate.getFullYear(), actDate.getMonth(), actDate.getDate(), 23, 59);
	//    }
	//    else {
	//        filter.value = '';
	//    }
	//}


	@Watch('filters')
	filtersDataChanged(value: string, oldValue: string) {
		if (value !== oldValue) {
			this.filtersBase = this.filters;
			this.changeParamTable();
		}
	}

	disabledRemoveFilter(): boolean {
		if (this.filters.filter((c: any) => c.default != undefined).length > 0) {
			return this.filters.filter((c: any) => c.selected).length == 1;
		}
		else {
			return false;
		}
	}

	showBackButtonTitleCalc(): string {
		return this.showBackButtonTitle;
	}

	showBackButtonTitleCalc2(): string {
		return this.showBackButtonTitle2;
	}

	showBackButtonTitleCalc3(): string {
		return this.showBackButtonTitle3;
	}

	closeWindow(): void {
		this.$emit('close', true);
	}


	removeFilterMulti(id: any, items: any) {
		this.removeMultiFilter(id.id, items.key, items.value);
		this.changeParamTable();
	}

	removeFilter(id: any): void {
		var filter = this.filters.filter((c: any) => c.key == id)[0];
		filter.selected = filter.default != undefined ? true : false;
		//TODO funguje pro vsechny typy filtru chce to proverit
		if (filter.group == undefined) {
			if (filter.type == 'datetime') {
				var actDate = new Date();
				filter.value = filter.moreThan ? new Date(actDate.getFullYear(), actDate.getMonth(), actDate.getDate(), 0, 0) :
					new Date(actDate.getFullYear(), actDate.getMonth(), actDate.getDate(), 23, 59);
			}
			else {
				//nezrusitelny filtr nastavit zpet...nechci
				if (filter.default != undefined) {
					filter.value = filter.default;
				}
				else {
					filter.value = '';
				}
			}
		}
		this.changeParamTable();
	}

	initBaseProperties() {
		this.fieldsBase = this.fields;
		this.filtersBase = this.filters;
		this.selectedBase = this.selected == null ? false : this.selected;
		this.itemsDataBase = this.itemsData;

		this.selectedMultiNamesBase = this.selectedMultiNames;
		this.nameBase = this.name == null ? '' : this.name;
		this.designBase = this.design == null ? '' : this.design;
		this.defaultSortByBase = this.defaultSortBy == null ? '' : this.defaultSortBy;
		this.defaultSortDescBase = this.defaultSortDesc == null ? false : this.defaultSortDesc;
		this.onlyOneBase = this.onlyOne == true;
	}

	private filterLabelClick(item: any, isGroup: boolean): void {

		if (isGroup) {
			var fil = this.filters.filter((c: any) => c.groupId == item.groupId && c.key != item.key) as Array<any>;
			var allIsFalse = fil.some((c: any) => c.selected);
			for (var i = 0; i < fil.length; i++) {
				fil[i].selected = !allIsFalse;
			}
			this.filters.filter((c: any) => c.groupId == item.groupId && c.key == item.key)[0].selected = true;
			//TOTO je navic
			this.changeParamTable();
		}
		else {
			if (item.showAnyTime != true) {
				this.filters.filter((c: any) => c.key == item.key)[0].selected = !this.filters.filter((c: any) => c.key == item.key)[0].selected;
				var filter = this.filters.filter((c: any) => c.key == item.key)[0];
				if (filter.selected) {
					let id = filter!.key + 'FilterInput';
					//multi select nedělám focus....
					if (filter.multiselect == undefined) {
						this.$nextTick(() => {
							document.getElementById(id)!.focus();
						})
					}
				}
			}
		}
	}

	//TODO jak lepe volat prvek  this.$refs.tags
	removeMultiFilter(id: any, key: any, filters: any): void {
		var tagFilter = this.filterData.filter((c: any) => c.key == key)[0];
		tagFilter.value = tagFilter.value.filter((c: any) => c.id != id);
		if (tagFilter.value.length == 0) {
			tagFilter.selected = false;
		}

		(this.$refs.tags as Array<any>)[0].clearMulti(id);
		if ((filters as Array<any>).length < 1) {
			var filter = this.filters.filter((c: any) => c.key == key)[0];
			filter.selected = false;
		}
	}

	protected resetAllFilters(): void {
		for (var i = 0; i < (this.filters as Array<any>).length; i++) {
			if (this.filters[i].showAnyTime != true) {
				if (this.filters[i].type == 'multi') {
					(this.$refs.tags as Array<any>)[0].clearMultiAll();
					this.filters[i].value = '';
					this.filters[i].selected = false;
				}
				else if (this.filters[i].default != undefined) {
					//  this.filters[i].value = this.filters[i].defaultSelected;
				}
				else if (this.filters[i].group == undefined) {
					this.filters[i].selected = false;
					this.clearInputFilter(this.filters[i]);
				}
				else {
					this.filters[i].selected = this.filters[i].isNegative ? true : false;
				}
			}
			else {
				this.clearInputFilter(this.filters[i]);
			}
		}
		this.setHeightTableNextTick();
		//NAVIC
		this.changeParamTable();
	}

	//END do predka
	isMounted = false;
	mounted() {
		this.isMounted = true;
		window.addEventListener('resize', () => {
			this.setHeightTableNextTick();

		});
		// this.setModalTag();
		this.setHeightTableNextTick();

		//POZOR nelze primo pouzit super.promena z predka !!!!!!!!!!!!  je treba to delat pres metodu
		//if (this.showInModal) {
		//	this.setShowInModalBase();
		//}
		//if (this.notChangeUrl) {
		//             this.setNotChangeUrlBase();
		//         }
	}

	setHeightTableNextTick(): void {
		this.$nextTick(() => {
			this.setHeightTable();
		});
	}


	setHeightTable(): void {
		var filterBlock = document.getElementById("idFilterSelected");
		var heightFilter = 0;
		if (filterBlock != null) {
			heightFilter = filterBlock.offsetHeight;
		}
		//dynamicky vypocet tabulky
		var heightGrid = this.isGridShow ? 20 : 0;
		var height = window.innerHeight - 170 - heightGrid - heightFilter;
		if (height < 250) {
			height = 250;
		}
		this.heightTable = (height - 10) + "px";
	}

	isLoading() {
		return this.isBusy && this.isBusyShow; //TODO priprivat && this.isBusyShow;
	}


	isSortable(data: any) {
		if (data.column == "selected") {
			return false;
		}

		return data.field['sortable'] == true
	}

	//tady tohle podbarví vybraný řádek
	rowClassSelected(item: any): string {
		if (item != undefined && this.selectedRowMain.indexOf(item.id) > -1) {
			return 'tableRowSelected';
		}
		else {
			return '';
		}
	}

	getFiltersByGroupsForShow() {
		return super.getFiltersByGroupsForShow();
	}

	useFilters() {
		return super.useFilters();
	}


	showIconGrid(): boolean {
		return this.allowGrid == true;
	}

	showIconFilters(): boolean {
		return this.getFilters().length > 0;// && !this.showFilterSetting && !this.showColumnSetting;
	}

	showIconClose(): boolean {
		const modalShow = this.showInModal == undefined ? false : this.showInModal;
		return modalShow && !this.showFilterSetting;
	}

	showIconColumnSetting(): boolean {
		return this.optionsColumns.length > 0 && !this.isGridShow;// && !this.showFilterSetting && !this.showColumnSetting;
	}

	showHideBlockFilter() {
		return this.showFilterSetting || this.showColumnSetting;
	}

	// #region NEXT PAGE

	//nextPageShow() {
	//    return ((this.perPage * this.currentPage) < this.totalRows) && this.scrollBarInDown;
	//}

	//nextPageTitle() {
	//    return this.$t('baseTable.nextPageTitle').toString() + (this.currentPage + 1);
	//}

	//scrollBarInDown = false;
	scrollTable(event: any) {
		this.scrollBarInDown = event.target.scrollTop + 10 + event.target.clientHeight > event.target.scrollHeight;
	}

	nextPage() {
		if ((this.perPage * this.currentPage) < this.totalRows) {
			this.currentPage = this.currentPage + 1;
		}
		//@ts-ignore
		var table = this.$refs.mainTab.$el;
		if (table != undefined) {
			table.scrollTop = 0;
		}
	}

	//počet všechn záznamů a aktuální stránka
	//sumaryAllItemsText() {
	//    let result = this.totalRows;
	//    let start = (this.currentPage - 1) * this.perPage + 1;
	//    let end = (this.currentPage) * this.perPage;
	//    if (end > this.totalRows) {
	//        end = this.totalRows;
	//    }

	//    if (this.totalRows == 0) {
	//        return this.$t('baseTable.noRecord');
	//    }
	//    return start + '-' + end + '/' + result;
	//}

	// #endregion NEXTPAGE


	//changeMultiSelectFilter(id: string, selectMulti: any): void {
	//    var key = id.replace('FilterInput', '');
	//    (this.filterData.filter(c => c.key == key)[0]).value = selectMulti;
	//    //když uz nebude vybran zadny tag tak se zrusi vyber filtru - docasne zruseno
	//    //if ((selectMulti as Array<any>).length == 0) {
	//    //	(this.filterData.filter(c => c.key == key)[0]).selected = false;
	//    //}
	//}

	//controlDown = false;
	//ctrlDownUp(isDown: boolean) {
	//    this.controlDown = isDown;
	//}

	detailClick(item: any): void {
		this.$emit('clickDetail', item);
	}

	closeModal() {
		this.$emit('closeModal', true);
	}

	getFilters() {
		var allowFilter = [];
		if (this.filters != null) {
			var filtersNotGroup = (this.filters as Array<any>).filter(c => (c.group == false || c.group == undefined) && c.default == undefined);
			for (var i = 0; i < filtersNotGroup.length; i++) {
				//filtr i pro skryty sloupec - specialka
				if (filtersNotGroup[i].showAnyTime) {
					allowFilter.push(filtersNotGroup[i]);
				}
				else if (this.fields.filter((c: any) => c.key == filtersNotGroup[i].key || c.key === filtersNotGroup[i].refItem).length > 0) {
					if (this.fields.filter((c: any) => c.key == filtersNotGroup[i].key || c.key === filtersNotGroup[i].refItem)[0].class.indexOf('collapse') > -1) {
						filtersNotGroup[i].selected = false;
					}
					else {
						allowFilter.push(filtersNotGroup[i]);
					}
				}
			}
		}
		return allowFilter;
	}

	getGroupFilters() {
		var allowFilter = [];
		if (this.filters != null) {
			var filtersGroup = (this.filters as Array<any>).filter(c => c.group == true && c.group != undefined);

			for (var i = 0; i < filtersGroup.length; i++) {
				allowFilter.push(filtersGroup[i]);
			}
		}
		return allowFilter;
	}


	// #region DESIGN

	classHead() {
		return this.simpleTable == true ? "settingColumnHeadSimple" : "settingColumnHead";
	}

	classFilterColumn() {
		var result = "";
		result += this.design == 'detail' ? " helpPositionAbsoluteX " : "";
		return result;
	}

	get isModalDesign() {
		return this.design == 'modalTable';
	}

	get inputClassHead() {
		return {
			"tabMenu": this.design == '',
			"tabMenuDetail": this.design == 'detail',
			"tabMenuNoBorder": this.design == 'modalTable'
		};
	}

	get inputClassHeadDescription() {
		return {
			"table-description-text": true,
			"table-description-text-detail": this.design == 'detail'
		};
	}

	get inputClassHeadAddIcon() {
		return {
			"iconsAddNew": this.design == '' || this.design == 'modalTable',
			"iconsAddNewDetail": this.design == 'detail'
		};
	}


	menuFixed(): string {
		return this.fixedMenu ? "menuFixedTable" : "";
	}

	// #endregion


	/**zapnuti filtru  UPRAVENO */
	clickFilterOn(key: string) {
		var filter = (this.filters as Array<any>).filter(c => c.key == key)[0];
		if (filter.showAnyTime != true) {
			filter.selected = filter.default != undefined ? true : !filter.selected;
			if (filter.selected) {
				let id = filter!.key + 'FilterInput';
				this.$nextTick(() => {
					document.getElementById(id)!.focus();
				})
			}
			else {

				if (filter.group == undefined) {
					this.clearInputFilter(filter);
				}
				if (filter.type == 'multi') {
					(this.$refs.tags as Array<any>)[0].clearMultiAll();
				}
			}
			this.setHeightTableNextTick();
			//TOTO je navic
			this.changeParamTable();
			this.isBusy = false;
		}
	}


	//VLATNI PRO TENTO PRVEK !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
	filtersOld = {};
	getItemsData() {
		//OTAZKA tady se to spusti nekolikrat PROC???
		//dalsi pokus aby se filterItemsRestTest provedl pouze jednou....nezabralo...ale necham zatim
		if (JSON.stringify(this.filters) != this.filtersOld) {
			this.filterItemsRest();

			this.filtersOld = JSON.stringify(this.filters);
		}

		//    this.filterItemsRestTest();

		this.totalRows = this.itemsData.countItems == undefined ? 0 : this.itemsData.countItems;
		return this.itemsData.items;
	}

	actualSortBy = "";
	actualSortDesc = false;
	//@ts-ignore
	sortChanged(item: any) {
		this.actualSortBy = item.sortBy;
		this.actualSortDesc = item.sortDesc;
		this.changeParamTable();
	}

	//změna jakehokoliv filtru
	changeFilter(id: any) {
		// this.filterItemsRest();
		this.changeParamTable();
	}

	getSelectedFilterToParam() {
		var result = {};
		var selectedFilter = this.filterData.filter((c: any) => c.selected);
		for (var i = 0; i < selectedFilter.length; i++) {
			//@ts-ignore
			result[selectedFilter[i].key] = selectedFilter[i].value;
		}

		return result;
	}

	//TODO nove
	beforeUpdate() {
		super.beforeUpdate();
	}

	updated() {
		super.afterUpdate();
	}

	designTypeNotNull(typ: any, name: string) {
		var result = this.designType(typ, name);
		if (result) {
			if (typ.value == '') {
				return false;
			}
		}
		return result
	}

	designType(typ: any, name: string) {
		if (name == '' && typ.field['design'] == undefined) {
			return true;
		}
		else if (typ.field['design'] == name) {
			return true;
		}
		else {
			return false;
		}
	}

	public changeParamTable() {
		//var tableParam = { perPage: this.perPage, currentPage: this.currentPage, sortBy: this.sortBy, sortDesc: this.sortDesc };
		var tableParam = { perPage: this.perPage, currentPage: this.currentPage, sortBy: this.actualSortBy, sortDesc: this.actualSortDesc };
		var filterSelected = this.getSelectedFilterToParam();
		//@ts-ignore
		tableParam['filters'] = filterSelected;
		this.$emit('changeParamTable', tableParam);
	}


	@Watch('perPage')
	onPropertyChangedPerPage(value: number, oldValue: number) {
		if (value !== oldValue) {
			this.changeParamTable();
		}
	}

	@Watch('currentPage')
	onPropertyChangedCurrentPage(value: number, oldValue: number) {
		if (value !== oldValue) {
			//@ts-ignore
			var table = this.$refs.mainTab.$el;
			if (table != undefined) {
				table.scrollTop = 0;
			}
			this.changeParamTable();
		}
	}



}
